const lables = ["Sleep", "Awake"]
const sa_chart_options = ({
    data
    // , categories
}) => ({
    title: {
        text: "",
        align: "left"
    },
    subtitle: {
        text: "",
        align: "left"
    },
    chart: {
        zoomType: "x",
        // type: "column",
        type: "arearange",
        panKey: "alt",
        panning: true,
        borderRadius: 8,
    },
    yAxis: {
        // tickAmount: 3,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        offset:26,
        labels: {
            reserveSpace: false,
            x:10,
            // step: 1,
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '12px'
            },
            formatter: function () {
                return lables[this.value]
            }
        },
        min: 0,
        max: 1
    },
    xAxis: {
        type: "datetime",
        // tickInterval: 3600 * 1000,
        ordinal: false,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        scrollbar: {
            enabled: false
        },
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        }
    },
    series: [{
        name: "Sleep Awake",
        showInLegend: false,
        // color: '#7F7F7F',
        fillColor: '#ffffff',
        color: '#0E95FC',
        step: true,
        data,
        gapSize: 2
    }],
    labels: {
        overflow: "scroll"
    },
    navigator: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    tooltip: {
        enabled: false,
    },
    plotOptions: {
        series: {
            name: "",
            pointPadding: 0,
            groupPadding: 0,
            gapSize: 0,
            displayInNavigator: false,
            // dataLabels: {
            //     allowOverlap: true,
            // }
        }
    },
    exporting: {
        enabled: true
    }
});

export default sa_chart_options;